import { EntityTypes } from 'models/entity';
import { ModuleAudit, Settings } from 'models/setting';

/**
 * The TENANT-level half of the audit module gate: the tenant switched the module on. The other half
 * is per audience and is not part of this helper: FeatureTypes.Audit for managing audits,
 * FeatureTypes.AuditParticipant for a team member opening the one audit they are named on.
 */
export const isAuditModuleEnabledForTenant = (settings: Settings | undefined): boolean => {
  return (settings?.get(ModuleAudit) as boolean) !== false;
};

/**
 * The route of an entity scene with one audit task selected in its resource pane. Returns undefined
 * for entity types without such a scene; a library document opens in the preview modal instead.
 */
export const getAuditTaskHref = (
  entityType: EntityTypes,
  entityId: number,
  auditTaskId: number | undefined,
  internalAuditId: number | undefined,
): string | undefined => {
  if (!auditTaskId || !internalAuditId) return undefined;

  const query = `auditTaskId=${auditTaskId}&internalAuditId=${internalAuditId}`;
  switch (entityType) {
    case EntityTypes.Control:
      return `/control/${entityId}/dashboard?${query}`;
    case EntityTypes.Requirement:
      return `/theme/${entityId}/dashboard?${query}`;
    case EntityTypes.Risk:
      return `/risk/${entityId}/dashboard?${query}`;
    case EntityTypes.Asset:
      return `/asset/${entityId}/dashboard?${query}`;
    case EntityTypes.Process:
      return `/process/${entityId}/details?${query}`;
    case EntityTypes.Objective:
      return `/objective/${entityId}/details?${query}`;
    case EntityTypes.ProcessingActivity:
      return `/processingactivity/${entityId}/dashboard?${query}`;
    default:
      return undefined;
  }
};
